import type { ComputedRef } from 'vue';

import type { SaleItemEntity, SaleListingItemEntity } from '~/types/sale.type';

type UseSdpTitleParams = MaybeRefOrGetter<SaleItemEntity | SaleListingItemEntity>;

type UseSdpTitleReturn = {
    title: ComputedRef<string>;
    busClass: ComputedRef<string | undefined>;
};

export const useSaleTitle = (sale: UseSdpTitleParams): UseSdpTitleReturn => {
    // COMPOSABLES
    const { tt } = useTypedI18n();
    const { isBundleMono, isBundleMulti } = useSaleType(() => toValue(sale)?.type);
    const { getPlatformBusClassesLabel } = usePlatformBusClass();

    // DATA
    const title = computed(() => {
        const _sale = toValue(sale);

        const assetsCount = 'assetCount' in _sale ? _sale.assetCount : _sale.assets.length;

        if (isBundleMulti.value) {
            return tt('sdp.multi.title', { count: assetsCount });
        }

        const _mainAsset = _sale.mainAsset;

        return `${isBundleMono.value ? `N. ${assetsCount} ` : ''}${_mainAsset.brand.brandValue} ${_mainAsset.model.modelValue}`;
    });

    const busClass = computed(() => {
        const _sale = toValue(sale);
        if (isBundleMulti.value || !_sale) return;

        return _sale.mainAsset.class ? getPlatformBusClassesLabel(_sale.mainAsset.class) : undefined;
    });

    return {
        title,
        busClass,
    };
};
